export class product_view_comments_controller {
  rateTypes = [];
  comment: any = {};
  user;
  rateAjaxLoding;
  comments;
  commentAjaxLoding;
  slider_ticks = {
    value: 3,
    options: {
      ceil: 5,
      floor: 0,
      showTicks: true,
      showSelectionBar: true
    }
  };
  constructor(
    private $rate,
    private $comment,
    private $user,
    private $state,
    private $notify
  ) {
    'ngInject';
  }

  $onInit() {
    this.$comment.query({ productId: this.$state.params.pID }, Response => {
      this.comments = Response.LstComment;
    });
  }
  reply(cm) {
    cm.reply = true;
    this.comment.ParnetId = cm.ID;
  }
  cancel(cm) {
    cm.reply = false;
    this.comment = {};
  }
  sendComment(cm) {
    this.commentAjaxLoding = true;
    this.comment.productId = this.$state.params.pID;
    this.$comment.insert(
      this.comment,
      respone => {
        this.$notify.show({ text: 'با تشکر! نظر شما با موفقیت ثبت شد' });
        this.comment = {};
        cm.reply = false;
        this.commentAjaxLoding = false;
      },
      reject => {}
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/product-view-comments/product-view-comments.controller.ts